import * as React from 'react'
import { cn } from '../../lib/utils'
import { PexIcon } from '../icons/PexIcon'
import type { PexIconName } from '../icons/pex-icon-registry'

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: React.ComponentType<{ className?: string }> | PexIconName
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 py-12 text-center',
        className,
      )}
    >
      {Icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-[var(--radius-panel)] bg-[var(--color-surface-muted)] shadow-[var(--shadow-hairline)]">
          {typeof Icon === 'string' ? (
            <PexIcon name={Icon} size="2xl" weight="duotone" tone="muted" />
          ) : (
            <Icon className="h-8 w-8 text-[var(--color-text-muted)]" />
          )}
        </div>
      )}
      <h3 className="text-sm font-semibold text-[var(--color-text)]">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-[var(--color-text-muted)]">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
